// extracted by mini-css-extract-plugin
module.exports = {"container":"articles_container__3EtfS","pdfContainer":"articles_pdfContainer__2DTDj"};